import React from 'react';
import { Wrapper, Row, Percent, Track, Fill } from './ProgressBar.styles';

/**
 * "Paso X de 5 · NN%" + lime bar. The bar and the percentage are decorative (aria-hidden);
 * the step text is read and is also part of document.title.
 */
const ProgressBar = ({ step, total, label }) => {
    const percent = Math.round((Math.min(step, total) / total) * 100);

    return (
        <Wrapper>
            <Row>
                <span>{label}</span>
                <Percent aria-hidden="true">{`${percent}%`}</Percent>
            </Row>
            <Track aria-hidden="true">
                <Fill style={{ width: `${percent}%` }} />
            </Track>
        </Wrapper>
    );
};

export default ProgressBar;
